import ContactsWidget from './ContactsWidget';

export default ContactsWidget;
